var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Modal',{attrs:{"title":"订单详情","width":800},model:{value:(_vm.config),callback:function ($$v) {_vm.config=$$v},expression:"config"}},[_c('Table',{attrs:{"columns":_vm.columns,"data":_vm.list}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }